import { render, staticRenderFns } from "./lesson-attendance.vue?vue&type=template&id=34d3a189&scoped=true"
import script from "./lesson-attendance.vue?vue&type=script&lang=js"
export * from "./lesson-attendance.vue?vue&type=script&lang=js"
import style0 from "./lesson-attendance.vue?vue&type=style&index=0&id=34d3a189&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d3a189",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d3a189')) {
      api.createRecord('34d3a189', component.options)
    } else {
      api.reload('34d3a189', component.options)
    }
    module.hot.accept("./lesson-attendance.vue?vue&type=template&id=34d3a189&scoped=true", function () {
      api.rerender('34d3a189', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/components/lesson-attendance.vue"
export default component.exports